<script>
import SamTooltipComponent from "@common/control/samTooltip";
import { componentStore } from "@common/componentStore/componentStore";

const labelWrapperConfig = {
    cId: 'labelWrapper',
    cType: 'labelWrapper',
    cTitle: 'Label Wrapper',
    cTemplate: `<div class="label-wrapper-inner" :class="{'sr-only':labelSettings.hideLabel}" v-if="labelSettings && labelSettings.id && (labelSettings.label || labelSettings.helpText)">
        <label :for="labelSettings.id" class="label-text" v-if="labelSettings.label && !labelSettings.noInputLabel"><span v-if="labelSettings.required" class="require-indicator">*<span class="sr-only">required</span></span>{{ddStoreFilter(labelSettings.label)}}</label>
        <span class="label-text" v-else-if="labelSettings.label && labelSettings.noInputLabel"><span v-if="labelSettings.required" class="require-indicator">*<span class="sr-only">required</span></span>{{ddStoreFilter(labelSettings.label)}}</span>
        <sam-tooltip
            v-if="labelSettings.helpText"
            ref="tooltip"
            opensOn="Click"
            :id="labelSettings.id + '_tooltip'"
            :css-class="tooltipClasses"
            :content="labelSettings.helpText"
            :label-classes="tooltipLabelClasses"
        ><span class="fa-regular fa-circle-info label-info"></span></sam-tooltip>
    </div>`,
};

const labelWrapperComp = {
    name: "labelWrapper",
    dataTestIds: [
        {
            querySelector: '.label-wrapper-inner .label-text',
            suffix: 'label'
        }
    ],
    props: {
        labelSettings: {
            type: Object,
            default: function () {
                return {
                    id: '',
                    label: '',
                    helpText: ''
                };
            },
        },
        uniqueStoreId: {
            default: true
        }
    },
    computed: {
        tooltipId() {
            return this.labelSettings.id + '_tooltip';
        },
        tooltipPosition() {
            return 'TopCenter';
        },
        tooltipClasses() {
            return 'label-wrapper-tooltip ' + this.tooltipId + ' ' + this.tooltipPosition;
        },
        tooltipLabelClasses() {
            return 'e-icons e-info help-tooltip ' + this.tooltipId;
        },
        dataTestId: {
            get: function () {
                let dataTestId = null;
                let parent = this.$parent;
                // @todo refactor to while
                for (let i = 0; i < 10; i++) { // NOSONAR
                    if (!parent) break;
                    if (parent && parent.dataTestId) {
                        dataTestId = parent.dataTestId;
                        break;
                    }
                    parent = parent.$parent;
                }
                let prefix = '';
                if (typeof this.uniqueStoreId === 'string') prefix = this.uniqueStoreId + "_";
                else if (this.fromPreview) prefix = 'preview_';
                return prefix + dataTestId + '_' + this.labelSettings.id + '_' + this.cId;
            }
        },
    },
    components: {
        'sam-tooltip': SamTooltipComponent
    }
};
componentStore.initComponent(labelWrapperComp, labelWrapperConfig);
export default labelWrapperComp;
</script>

<style scoped>
.label-text {
    font-size: 16px;
}
.label-wrapper-inner {
    display: flex;
    margin-top: 15px;
    margin-bottom: 5px;
}
.display-flex .label-wrapper-inner {
    margin-top: 10px;
}
.label-wrapper-inner label {
    margin-right: 10px;
}
.label-wrapper-inner .require-indicator {
    font-weight: bold;
    font-size: 1.1em;
    margin-right: 3px;
    color: #b70101;
}
.label-wrapper-inner.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
.label-info {
    font-size: 16px;
    cursor: pointer;
}
</style>
